<template>
    <div class="card shadow-sm">
        <div class="card-header">
        <h3 class="card-title">
            <ul class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold">
                <li class="nav-item" @click="toggleStandTab('tab-participators')" v-if="$can(abilities.CAN_VIEW_EVENT_PARTICIPANT) || $can(abilities.CAN_VIEW_EVENT_ALL_PARTICIPANT)">
                    <a class="nav-link text-active-primary ms-0 me-10" :class="{'active' : route.query.tab === 'tab-participators' }" data-bs-toggle="tab" href="#tab-participators">
                    {{ $t('events.participators') }}
                    </a>
                </li>
                <li class="nav-item mt-2" @click="toggleStandTab('tab-badges')">
                    <a class="nav-link text-active-primary ms-0 me-10 py-5" :class="{'active' : route.query.tab === 'tab-badges' }" data-bs-toggle="tab" href="#tab-badges">
                        {{ $t('events.badges') }}
                    </a>
                </li>
                <li class="nav-item mt-2" @click="toggleStandTab('tab-stands')">
                    <a class="nav-link text-active-primary ms-0 me-10 py-5" :class="{'active' : route.query.tab === 'tab-stands' }"  data-bs-toggle="tab" href="#tab-stands">
                        {{$t("events.stands.title")}}
                    </a>
                </li>
            </ul>
        </h3>
        </div>
        <div class="card-body">
            <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show " :class="{'active' : route.query.tab === 'tab-participators'  }" v-if="$can(abilities.CAN_VIEW_EVENT_PARTICIPANT) || $can(abilities.CAN_VIEW_EVENT_ALL_PARTICIPANT)" id="tab-participators" role="tabpanel">
                    <ParticipatorTab ref="participatorTab" />
                </div>
                <div class="tab-pane fade show " :class="{'active' : route.query.tab === 'tab-badges' }" id="tab-badges" role="tabpanel">
                    <BadgeIndex/>
                </div>
                <div class="tab-pane fade show " :class="{'active' : route.query.tab === 'tab-stands' }" id="tab-stands" role="tabpanel">
                    <div class="d-flex justify-content-end mb-5">
                        <div class="mt-3 me-3">
                            <Button type="new" btn-class="btn-md" btn-text="events.stands.create" @click="openCreateView"></Button>
                        </div>
                        <div class="col-3">
                            <Input
                                inputClass="form-control form-control-sm"
                                name="input-search"
                                :isInputGroup="true"
                                :placeholder="$t('label.search')"
                                :action="loadDataForSearch"
                                v-model="query.search"
                            >
                                <template #rightAddon>
                                    <span class="position-absolute border-0 bg-transparent end-0 top-50 translate-middle me-3" @click="loadDataForSearch">
                                    <i class="fa fa-search"></i>
                                    </span>
                                </template>
                            </Input>
                        </div>
                    </div>
                    <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="events_stand_datatable">
                        <thead class="mb-5">
                        <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
                            <th class="text-center">{{ $t("events.stands.name") }} </th>
                            <th class="text-center">{{ $t('events.stands.number') }} </th>
                            <th class="text-center">{{ $t("events.stands.participator") }} </th>
                            <th class="text-center">{{ $t('events.stands.location')}}</th>
                            <th class="text-center">{{ $t("events.stands.actions") }}</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-if="stands?.length > 0" v-for="(stand, index) in stands" :key="index">
                                <td class="text-center">{{ stand.name ?? '' }}</td>
                                <td class="text-center">{{ stand.number ?? '' }}</td>
                                <td class="text-center">{{ stand.participator?.fullname ?? '' }}</td>
                                <td class="text-center">{{ stand.location ?? '' }}</td>
                                <td class="text-center">
                                    <a @click.prevent="updateStand(stand)" style="cursor: pointer;"  class="btn btn-sm btn-clean btn-icon" :title="$t('button.edit')"><i class="fas fa-edit fs-2" :style="{color: Theme.gray}"></i></a>
                                    <a @click.prevent="deleteStand(stand.id)" style="cursor: pointer;"  class="btn btn-sm btn-clean btn-icon" :title="$t('button.delete')"><i class="fas fa-trash fs-2" :style="{color: Theme.gray}"></i></a>
                                </td>
                            </tr>
                            <tr v-else class="text-center justify-content-center">
                                <td class="py-5" colspan="5">
                                    <div class="text-gray-400 fs-4 fw-bold">{{ $t('no_data_found') }}</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

    <StandFormModal id="create_event_stand_modal" @load="loadData"/>
    <StandFormModal id="edit_event_stand_modal" :edit="true" :form="formUpdate" @load="loadData"/>
</template>

<script setup>
    import {computed, nextTick, onMounted, ref, watch} from "vue";
    import {useStore} from "vuex";
    import {useRoute, useRouter} from "vue-router";
    import {useLocales} from "@/composables/locales";
    import {useSwal} from "@/composables/useSwal";
    import i18n from "@/plugins/i18n";
    import Button from "@/components/Button.vue";
    import StandFormModal from "./modals/StandFormModal.vue";
    import {Theme} from "@/composables/theming";
    import Input from "@/components/Input.vue"
    import BadgeIndex from "../badges/Index.vue";
    import ParticipatorTab from "@/Modules/Events/views/events/components/ParticipatorTab.vue";
    import abilities from "@/composables/abilities";

    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    const {locale} = useLocales()
    
    const {showSwal} = useSwal()
    
    const formUpdate = ref({
        id: '',
        event_id: '',
        name: '',
        number: '',
        location: '',
        participator_id: '',
        members: []
    })
    const query = ref({
        search: '', 
        event_id: ''
    })

    const stands = computed(() => store.getters['stands/getStands'])
  
    watch(() => locale.value, (value) => {
        nextTick(() => loadData())
    }, { deep: true })

    watch(() => route.query.tab, (value) => {
        if(value) {
            loadData()
        }
    })

    watch(() => query.value.search, async(value) => {
        if (!value) {
            loadData()
        }
    });

    function deleteStand(id) {
        showSwal(
            i18n.global.t('events.stands.swal_deleted'),
            i18n.global.t('events.stands.swal_deleted_text')
        ).then( async (result) => {
        if (result.value) {
            store.dispatch('stands/deleteStand', id)
            .then(() => {
                window.toastr['success'](i18n.global.t('events.stands.deleted_successfully'))
                loadData()
            })
            .catch(() => {
                
            })
        }
        })
    }

    function openCreateView() {
        $('#create_event_stand_modal').modal('toggle')
    }

    function updateStand(data) {
        formUpdate.value = {
            id: data?.id,
            event_id: data?.event_id,
            name: data.name,
            number: data.number,
            location: data.location,
            participator_id: data.participator_id,
            members: data.members?.map(el => el.id)
        }

        $('#edit_event_stand_modal').modal('toggle')
    }

    function loadDataForSearch() {
        if(query.value.search) loadData()
    }

    function loadData() {
        if(route.query.tab == 'tab-stands'){
            store.dispatch('stands/loadStands', {...query.value, event_id: route.params.id})
        }
    }

    onMounted( () => {
        loadData()
    })

    function toggleStandTab(tab){
        router.replace({ query: { ...route.query, tab } });
    }
</script>

<style scoped>
  .card-header {
    padding-bottom: 0;
  }

  .nav.nav-line-tabs {
    align-items: flex-end;
    height: 100%;
  }

  .nav-line-tabs.nav-line-tabs-2x .nav-item {
    margin-bottom: -8px;
  }

  .nav-line-tabs .nav-item {
    height: 100%;
    display: flex;
    align-items: flex-end;
  }

  .nav-line-tabs .nav-link {
    border-bottom: 2px solid transparent;
    padding-bottom: 15px; 
  }
</style>